
import React from 'react';
import { Link } from 'react-router-dom';
import { LineChart, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import StatisticCard from '@/components/dashboard/StatisticCard';
import { StatisticData } from '@/types';

interface PerformanceMetricsProps {
  stats: StatisticData[];
}

const PerformanceMetrics: React.FC<PerformanceMetricsProps> = ({ stats }) => {
  return (
    <section className="space-y-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <h2 className="text-2xl font-bold flex items-center gap-2">
          <LineChart className="h-6 w-6 text-neon-purple" />
          Performance Metrics
        </h2>
        <Button variant="ghost" size="sm" className="text-neon-purple" asChild>
          <Link to="/analytics" className="flex items-center gap-1">
            Detailed Analytics
            <ArrowRight className="h-4 w-4" />
          </Link>
        </Button>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((stat, index) => (
          <StatisticCard
            key={index}
            title={stat.title}
            value={stat.value}
            change={stat.change}
            positive={stat.positive}
            icon={stat.icon}
            color={stat.color}
          />
        ))}
      </div>
    </section>
  );
};

export default PerformanceMetrics;
